<template>
    <div class="form form__coststable">
        <ul>
            <li
                v-for="(item, parentIndex) in newItems"
                :key="parentIndex"
            >
                <div class="form__coststable_content">
                    <div class="columns is-vcentered">
                        <div class="column">
                            <div class="form__coststable_content_name">{{item.name}}</div>
                        </div>
                        <div class="column is-narrow">
                            <div class="form__coststable_content_price">
                                <form-price
                                    :disabled="disabled"
                                    :name="item.name | toKebabCase"
                                    :value="item.value"
                                    @input="emitInput(item, parentIndex, -1, ...arguments)"
                                />
                            </div>
                        </div>
                        <div class="column is-narrow">
                            <div class="form__coststable_content_switch">
                                <button
                                    type="button"
                                    class="form__coststable_content_switch_button btn btn--icon"
                                    id="form-coststable-content-switch-button-right"
                                >
                                    <v-icon name="chevron-right"></v-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form__coststable_subtable">
                    <ul>
                        <li
                            v-for="(service, childIndex) in item.services"
                            :key="childIndex"
                        >
                            <div class="form__coststable_subtable_content">
                                <div class="columns is-vcentered">
                                    <div class="column">
                                        <div class="form__coststable_subtable_content_name">
                                            {{service.name}}
                                        </div>
                                    </div>
                                    <div class="column is-narrow">
                                        <div class="form__coststable_subtable_content_price">
                                            <form-price
                                                :disabled="disabled"
                                                :name="item.name + '-' + service.name | toKebabCase"
                                                :value="service.value"
                                                @input="emitInput(service, parentIndex, childIndex, ...arguments)"
                                            />
                                        </div>
                                    </div>
                                    <div class="column is-narrow">
                                        <div class="form__coststable_subtable_content_blank"></div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
        <template v-if="$slots.default">
            <div class="form__coststable_hint">
                <slot></slot>
            </div>
        </template>
    </div>
</template>

<script>
import FormPrice from '@/components/default/forms/FormPrice'

export default {
  components: { FormPrice },
  name: 'form-coststable',
  data () {
    return {
      reloaded: false
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    items: {
      required: true
    },
    values: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    newItems: function () {
      const itemsArr = JSON.parse(JSON.stringify(this.items))
      const valuesArr = JSON.parse(JSON.stringify(this.values))
      if (!itemsArr.length) return
      for (let i = 0; i < valuesArr.length; i++) {
        let valueParentIndex
        let valueChildIndex
        switch (valuesArr[i].referenceType) {
          case 'sector':
            valueParentIndex = itemsArr.findIndex(
              itemsArrObj => valuesArr[i].referenceType === 'sector' &&
              Number(itemsArrObj.reference.id) === Number(valuesArr[i].reference.id)
            )
            itemsArr[valueParentIndex].value = valuesArr[i].value
            break
          case 'service':
            for (let j = 0; j < itemsArr.length; j++) {
              valueChildIndex = itemsArr[j].services.findIndex(
                itemsArrServicesObj => valuesArr[i].referenceType === 'service' &&
                  Number(itemsArrServicesObj.reference.id) === Number(valuesArr[i].reference.id)
              )
              if (valueChildIndex > -1) {
                valueParentIndex = j
                break
              }
            }
            itemsArr[valueParentIndex].services[valueChildIndex].value = valuesArr[i].value
            break
        }
      }
      return itemsArr
    }
  },
  methods: {
    collapseInteractivity: function () {
      if (!this.items.length || this.reloaded) return
      this.reloaded = true
      let buttons = document.getElementsByClassName('form__coststable_content_switch_button')
      for (let i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener('click', function () {
          let thisButton = buttons[i]
          let thisSubmenu = thisButton.closest('.form__coststable_content').nextElementSibling
          if (thisButton.classList.contains('active')) {
            thisButton.classList.remove('active')
          } else {
            thisButton.classList.add('active')
          }
          if (thisSubmenu.classList.contains('active')) {
            thisSubmenu.classList.remove('active')
          } else {
            thisSubmenu.classList.add('active')
          }
        }, false)
      }
    },
    //
    emitInput: function (item, parentIndex, childIndex, value) {
      this.$emit('input', { item: item, parentIndex: parentIndex, childIndex: childIndex, value: value })
    }
  },
  mounted () {
    const self = this
    setTimeout(function () {
      self.collapseInteractivity()
      self.$store.dispatch('setServicesDefault', self.newItems)
    }, 100)
  },
  watch: {
    newItems: function () {
      const self = this
      setTimeout(function () {
        self.collapseInteractivity()
      }, 100)
    }
  },
  inject: ['$validator']
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/forms/formcoststable";
</style>
